
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-dashboard",
      function () {
        return require("private-next-pages/my-dashboard.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-dashboard"])
      });
    }
  